export const convertToCamelCase = <T extends string>(str: string): T => {
  const result = str.includes('-')
    ? str
        .split('-')
        .map((word, index) => (index === 0 ? word : word[0].toUpperCase() + word.slice(1)))
        .join('')
    : str;
  return result as T;
};

export const convertToKebabCase = <T extends string>(str: string): T => {
  const result = str.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
  return result as T;
};

export const isReviewAccount = (accountId: string) => accountId === '6613e71d7d797c474bc41f7f';

export function isValidObjectId(id: string) {
  return /^[0-9a-fA-F]{24}$/.test(id);
}
